// TODO use/update models
import { CrudState } from "@/store/modules/crud/State";
import IAdmin from "@/models/IAdmin";

export class State extends CrudState {
  dataList: Array<IAdmin> = [];
  dataItem: IAdmin | null = null;
}
